import {Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy, Output, EventEmitter} from '@angular/core';
import {GridOptions, ColDef, ColGroupDef, IDatasource, IGetRowsParams, GridApi} from 'ag-grid-community';
import {LoadingService} from 'src/app/services/loading/loading.service';
import {IffShipmentSummaryService} from 'src/app/services/iff-shipment-summary/iff-shipment-summary.service';
import {Observable, BehaviorSubject} from 'rxjs';
import {
  PageResponse,
  IFFShipmentSummaryResponse,
  HHGIffShipmentDetailResponse,
  FRTIffShipmentDetailResponse
} from 'src/app/shared/common-components/common-structure';
import {takeWhile} from 'rxjs/operators';
import {BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import {DownloadFileResponse} from 'src/app/shared/common-components/file-storage/downloadFileResponse';
import * as FileSaver from 'file-saver';
import {ButtonRendererComponent} from 'src/app/features/frt-rates-download/ButtonRendererComponent';
import {AlertService} from 'src/app/services/alert/alert.service';
import {hhg_iff_download_success, frt_iff_download_success, api_error} from 'src/app/shared/common-components/AppConstants';
import {IffShipmentDetailsService} from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import {Router} from '@angular/router';
import { CustomHeader } from "./iff-shipment-summary-custom-header.component";
import {formatDate} from "@angular/common";
import moment from 'moment';

@Component({
    selector: 'app-iff-shipment-summary',
    templateUrl: './iff-shipment-summary.component.html',
    styleUrls: ['./iff-shipment-summary.component.css'],
    standalone: false
})
export class IffShipmentSummaryComponent implements OnInit, OnChanges, OnDestroy {

  private observer$ = new BehaviorSubject(true);
  private isNoRowSelectedEvent$ = new BehaviorSubject(true);
  isNoRowSelected$ = this.isNoRowSelectedEvent$.asObservable();
  gridOptions: GridOptions;
  gridOptionsApi: any;
  detailGridOptions: GridOptions;
  modalRef: BsModalRef;
  frameworkComponents: any;
  iffMasterId: number;
  endRoute: String;

  @Input() title: string;
  @Input() isFRTShipment = false;
  // @Input() updateIFFShipmentPaginationRequestFn: any;
  @Input() updateIFFShipmentDetailRequestFn: any;
  @Input() IFFShipmentDetailsColumnDefs: (ColDef | ColGroupDef)[];
  @Input() IFFShipmentPaginationResults$: Observable<PageResponse<IFFShipmentSummaryResponse>>;
  @Input() IFFShipmentDetailResults$: Observable<HHGIffShipmentDetailResponse[] | FRTIffShipmentDetailResponse[]>;
  // @Output() IFFShipmentSelected = new EventEmitter<IFFShipmentSummaryResponse>();
  @Output() delinquencyReportSelected = new EventEmitter();
  @Output() comprehensiveReportSelected = new EventEmitter();
  private gridApi!: GridApi<any>;


  IffShipmentSummaryColumnDefs: (ColDef | ColGroupDef)[] = [
    <ColDef>{
      checkboxSelection: true,
      width: 80
    },
    {
      headerName: 'SCAC Code',
      field: 'scac',
      filter: 'agTextColumnFilter',
      sortable: true,
      cellRenderer: 'agGroupCellRenderer', chartDataType: 'category'
      // onCellClicked: event => this.onSCACClicked(event.data)
    },
    {
      headerName: 'TSP Name',
      field: 'scacName',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series'
    },
    {
      headerName: 'Reporting Year',
      field: 'reportingYear',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series'
    },
    {
      headerName: 'Reporting Quarter',
      field: 'reportingQuarter',
      filter: 'agTextColumnFilter',
      sortable: true, chartDataType: 'series'
    },
    {
      headerName: 'Status',
      field: 'status',
      filter: 'agTextColumnFilter',
      sortable: true,
      chartDataType: 'series'
    },
    {
      headerName: 'Move Type',
      field: 'moveType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Type of Transportation',
      field: 'transportationType',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Processing Date & Time',
      field: 'receivedDate',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Number of Shipments',
      field: 'numberOfShipments',
      filter: 'agTextColumnFilter',
      sortable: true,
      comparator: this.iffShipmentSummaryService.numberComparator
    },
    {
      headerName: 'Gross Amount',
      field: 'grossAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Net Amount',
      field: 'netAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Pass-Through Amount',
      field: 'passThruAmount',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      // headerName: 'Total AF \n Prior to 01/01/2025, amounts included UAB',
      headerComponent: CustomHeader,
      field: 'totalIFF',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueFormatter: this.iffShipmentSummaryService.formatNumber,
      comparator: this.iffShipmentSummaryService.currencyComparator
    },
    {
      headerName: 'Pay.gov Payment Status',
      field: 'paymentStatus',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: params => {
        if (this.title === 'HHG Shipment Reports Master List' || this.title === 'SIT Shipment Reports Master List') {
          if (params.data.totalIFF === "0.00") {
            return '';
          } else if (params.data.paymentStatus === 'Success' || params.data.paymentStatus === 'Received' || params.data.paymentStatus === 'Waiting'  || params.data.paymentStatus === 'Submitted') {
            return 'Pending';
          } else if (params.data.paymentStatus === 'Settled' || params.data.paymentStatus === 'Reconciled') {
            return 'Accepted';
          } else if (params.data.paymentStatus === 'Failed' || params.data.paymentStatus === 'Cancelled' || params.data.paymentStatus === 'Retired' || params.data.paymentStatus === 'Denied' || params.data.paymentStatus === 'Disputed' || params.data.paymentStatus === 'Unknown') {
            return 'Rejected';
          } else {
            return '';
          }
        }
        return params.data.paymentStatus;
      },
        cellRenderer: params => {
      // Keep the cellRenderer for display purposes
        return params.value; // Use params.value, which is now the processed value from valueGetter
      }
    },
    {
      headerName: 'Pay.gov Payment Date',
      field: 'paymentDate',
      valueGetter: (params) => {
        return params.data.paymentDate ? moment(params.data.paymentDate, "YYYY-MM-DD HH:mm:ss").format("MM-DD-YYYY hh:mm A") : '';
      },
      comparator: this.iffShipmentSummaryService.dateComparator,
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Pay.gov Date Posted',
      field: 'paymentReconciledDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      comparator: this.iffShipmentSummaryService.dateComparator,
      valueGetter: (params) => {
        return params.data.paymentReconciledDate ? moment(params.data.paymentReconciledDate, "YYYY-MM-DD HH:mm:ss").format("MM-DD-YYYY hh:mm A") : '';
      },
    },
    {
      headerName: 'Pay.gov Tracking ID',
      field: 'paygovTrackingId',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'TMSS Tracking ID',
      field: 'tmssTrackingId',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Paid By',
      field: 'createdUser',
      filter: 'agTextColumnFilter',
      sortable: true
    },
    {
      headerName: 'Payment Method',
      field: 'paymentMethod',
      filter: 'agTextColumnFilter',
      sortable: true
    },
  ];

  disableExport = false;

  constructor(private iffShipmentSummaryService: IffShipmentSummaryService,
              private alertService: AlertService, private loader: LoadingService,
              private modalService: BsModalService, private iffShipmentDetailsService: IffShipmentDetailsService,
              private router: Router) {
  }

  ngOnInit() {
    this.endRoute = this.router.url.substring(1);
  }

  onExport() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'The current iff rates download file contains data from the table view only, if you need all data with filters,' +
      'please click option No.';
    this.modalRef.content.title = 'Do you want to download rates from the table view ?';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No - download all rates with filters';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        const date = new Date();
        const params = {
          fileName: this.isFRTShipment ? 'FRT' : 'HHG' + ' iff-rates-report-' + date + '.csv',
          allColumns: true,
          columnSeparator: ','
        };
        this.gridOptionsApi.exportDataAsCsv(params);

      } else if (result.obj === false) {
        this.disableExport = true;
        this.loader.show();
        this.iffShipmentSummaryService
          .exportIFFShipmentSummary(this.isFRTShipment).pipe(takeWhile(() => this.observer$.value))
          .subscribe((iffShipmentSummary: DownloadFileResponse) => {
            const byteData: number[] = iffShipmentSummary.byteData;
            const fileName: string = iffShipmentSummary.fileName;
            const numRows: number = iffShipmentSummary.numberOfExcelRows;
            const bytes = new Uint8Array(byteData);
            const blob = new Blob([bytes], {
              type: null
            });
            console.log(numRows);
            FileSaver.saveAs(blob, fileName);
            this.alertService.success(this.isFRTShipment ? hhg_iff_download_success : frt_iff_download_success);
          }, error => {
            this.loader.hide();
            this.alertService.error(api_error);
          }, () => {
            this.loader.hide();
            this.disableExport = false;
          });
      }
    });
  }

  sendEmailFromClient() {
    this.iffShipmentSummaryService.sendTestEmail().subscribe(data => {
      console.log(data);
    }, error => {
      console.log(error);
    });
  }

  onDelete() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this Shipment Report Record(s)?';
    this.modalRef.content.title = 'Deleting Shipment Reports';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        const selectedRows = this.gridOptionsApi.getSelectedRows();
        this.iffShipmentSummaryService.deleteIffShipment(selectedRows.map(iff => +iff.iffMasterId))
          .subscribe(() => {
            this.loader.hide();
            this.alertService.success('Successfully Deleted Shipment Report Record');
            // remove rows locally from the currently-displayed data and trigger a full refresh
            try {
              const selectedIds = selectedRows.map(r => +r.iffMasterId);
              const currentRows: any[] = [];
              // collect current displayed rows
              this.gridOptionsApi.forEachNode(node => {
                if (node && node.data) {
                  currentRows.push(node.data);
                }
              });
              const remaining = currentRows.filter(r => !selectedIds.includes(+r.iffMasterId));
              // replace the grid data with the filtered set
              this.gridOptionsApi.setRowData(remaining);
            } catch (e) {
              // fallback to updateRowData if above fails
              this.gridOptionsApi.updateRowData({remove: selectedRows});
            }
            // re-query backend streams so parent pagination observables update
            this.iffShipmentSummaryService.refreshAllShipmentSummaries();
            setTimeout(() => {
              if (this.gridOptionsApi) {
                this.gridOptionsApi.refreshCells({force: true});
                this.gridOptionsApi.redrawRows();
              }
            }, 500);
          }, err => {
            this.loader.hide();
            this.alertService.error('There was an error deleting Shipment Report');
          });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.detailGridOptions = <GridOptions>{
      columnDefs: this.IFFShipmentDetailsColumnDefs,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      suppressDragLeaveHidesColumns: true,
      onGridReady: params => {
        // this.IFFShipmentDetailResults$.subscribe(results => params.api.setRowData(results));
        //params.api.sizeColumnsToFit();
        this.gridApi = params.api;
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
    this.gridOptions = <GridOptions>{
      columnDefs: this.IffShipmentSummaryColumnDefs,
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: false
        }
      },
      masterDetail: true,
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      // domLayout: 'autoHeight',
      rowSelection: 'multiple',
      rowMultiSelectWithClick: true,
      suppressDragLeaveHidesColumns: true,
      detailCellRendererParams: {
        detailGridOptions: this.detailGridOptions,
        getDetailRowData: params => {
          this.loader.show();
          this.updateIFFShipmentDetailRequestFn(params.data['iffMasterId'])
            .pipe(takeWhile(() => this.observer$.value))
            .subscribe(results => {
              params.successCallback(results);
              this.loader.hide();
            }, error => this.loader.hide());
        }
      },
      isRowMaster: rowData => rowData ? rowData.numberOfShipments > 0 : false,
      onGridReady: params => {
        this.gridOptionsApi = params.api;
        if (this.isFRTShipment === true) {
          params.api.getColumnDef('passThruAmount').headerName = 'Fuel Surcharge Cost';
          params.api.refreshHeader();
        }
        params.api.sizeColumnsToFit();
        // params.api.setDatasource(this.getIFFShipmentQueryDataSource(this.updateIFFShipmentPaginationRequestFn,
        //   this.IFFShipmentPaginationResults$));
      },
      onSelectionChanged: params => {
        const selectedRows = params.api.getSelectedNodes();
        if (selectedRows && selectedRows.length > 0) {
          this.isNoRowSelectedEvent$.next(false);
        } else {
          this.isNoRowSelectedEvent$.next(true);
        }
      },
      defaultExportParams: {
        getCustomContentBelowRow: params => {
          return [];
        }
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  // Changed to ClientSide
  getIFFShipmentQueryDataSource(updateIFFShipmentPaginationRequestFn: any,
                                IFFShipmentPaginationResults$: Observable<PageResponse<IFFShipmentSummaryResponse>>): IDatasource {
    return <IDatasource>{
      getRows: (params: IGetRowsParams) => {
        this.loader.show();
        updateIFFShipmentPaginationRequestFn(
          this.gridApi.paginationGetCurrentPage(),
          this.gridApi.paginationGetCurrentPage() + 1,
          params.filterModel,
          params.sortModel
        );
        IFFShipmentPaginationResults$
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(
            pageResponse => {
              this.loader.hide();
              params.successCallback(
                pageResponse.content,
                pageResponse.totalElements
              );
            },
            error => {
              this.loader.hide();
              params.failCallback();
            }
          );
      }
    };
  }

  // onSCACClicked(iffShipmentSummaryResponse: IFFShipmentSummaryResponse){
  //   this.IFFShipmentSelected.emit(iffShipmentSummaryResponse);
  // }

  onDelinquencyReportClicked() {
    this.delinquencyReportSelected.emit();
  }

  onComprehensiveReportClicked() {
    this.comprehensiveReportSelected.emit();
  }

  ngOnDestroy() {
    this.observer$.next(false);
  }

}
